import React from 'react';
import Decimal from 'decimal.js';
import { Box, Divider } from '@wix/design-system';
import { DepositType } from '@wix/ambassador-wix-quotes-web/types';
import { hasDeposit } from '../../../DocParts/Totals/Deposit/hasDeposit';
import { Amount } from '../Amount';
import { InfoLine } from '../InfoSection';
export const InvoiceSummary = ({ formatMoney, balance, deposit, discount, fees, paid, subtotal, taxes, total, taxedTotal, showTaxBreakdown, showItemsSubtotalPerTax, taxAdjustmentsEnabled, t, }) => {
    const isDepositDue = hasDeposit({
        depositAmount: deposit.amount,
        paidAmount: paid,
    });
    const AmountWithFormatter = (props) => React.createElement(Amount, { formatMoney: formatMoney, ...props });
    const renderFees = () => {
        return fees.map(({ name, price }, index) => (React.createElement(AmountWithFormatter, { key: `${name}-${index}`, title: name, amount: price })));
    };
    const renderTaxes = () => {
        return (React.createElement(React.Fragment, null,
            (!showTaxBreakdown || (showTaxBreakdown && taxes.length === 0)) && (React.createElement(AmountWithFormatter, { title: t('price-quote.view.totals.taxes'), amount: taxes
                    .reduce((sum, tax) => sum.add(tax.amount), new Decimal(0))
                    .toNumber() })),
            showTaxBreakdown && taxes.length > 0 && (React.createElement(React.Fragment, null,
                taxAdjustmentsEnabled && (React.createElement(Box, null,
                    React.createElement(InfoLine, { dataHook: "tax-breakdown", weight: "bold" }, t('price-quote.view.totals.tax-breakdown')))),
                taxes.map((tax, index) => (React.createElement(AmountWithFormatter, { key: `${tax.name}-${tax.rate}-${index}`, title: `${tax.name} (${tax.rate}%)`, amount: tax.amount }))),
                taxAdjustmentsEnabled && (React.createElement(AmountWithFormatter, { key: "tax-total", title: t('price-quote.view.totals.tax-total'), amount: taxedTotal, weight: "bold" })))),
            taxAdjustmentsEnabled &&
                showItemsSubtotalPerTax &&
                taxes.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(Box, { marginTop: "12px" },
                    React.createElement(Divider, null)),
                React.createElement(Box, { marginTop: "12px" },
                    React.createElement(InfoLine, { dataHook: "items-subtotal-per-tax-group", weight: "bold" }, t('price-quote.view.totals.items-subtotal-per-tax'))),
                taxes.map((tax, index) => (React.createElement(AmountWithFormatter, { key: `${tax.name}-${tax.rate}-items-subtotal-${index}`, title: `${tax.name} (${tax.rate}%)`, amount: tax.taxable })))))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(InfoLine, { type: "heading", paddingTop: "24px" }, t('price-quote.mobile-view.totals.title')),
        React.createElement(AmountWithFormatter, { marginTop: "12px", title: t('quote.form.net-total'), amount: subtotal }),
        renderFees(),
        discount.rate > 0 && (React.createElement(AmountWithFormatter, { title: t('price-quote.view.totals.discount', { rate: discount.rate }), amount: -1 * discount.amount })),
        renderTaxes(),
        taxAdjustmentsEnabled && (React.createElement(Box, { marginTop: "12px" },
            React.createElement(Divider, null))),
        React.createElement(AmountWithFormatter, { weight: "bold", marginTop: "12px", title: t('quoteview.uou_total'), amount: total }),
        isDepositDue && (React.createElement(AmountWithFormatter, { title: deposit.type === DepositType.PERCENTAGE
                ? t('quoteview.uou_percentage_deposit', {
                    percentage: deposit.rate,
                })
                : `${t('quote.form.deposit')}`, amount: deposit.amount })),
        React.createElement(AmountWithFormatter, { title: t('quote.form.amount_paid'), amount: -1 * paid }),
        React.createElement(Box, { marginTop: "12px" },
            React.createElement(Divider, null)),
        React.createElement(AmountWithFormatter, { type: "heading", marginTop: "12px", title: isDepositDue ? t('quote.form.deposit-due') : t('quote.form.balance'), amount: isDepositDue ? Decimal.sub(deposit.amount, paid).toNumber() : balance })));
};
//# sourceMappingURL=InvoiceSummary.js.map